module.exports = __webpack_public_path__ + "static/ambasador_raczkiewicz-f42de44bd67fcf971fac1ad2a06e65e6.png";